import React from 'react';

const YouTube = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 25 18"
		fill="none"
		{...props}
	>
		<path
			fill="#6B6279"
			d="M23.873 4.611s-.234-1.654-.956-2.38c-.914-.957-1.936-.962-2.404-1.018-3.357-.244-8.396-.244-8.396-.244h-.01s-5.038 0-8.394.244c-.47.056-1.491.06-2.405 1.017-.722.727-.952 2.381-.952 2.381S.113 6.557.113 8.497v1.82c0 1.94.239 3.885.239 3.885s.234 1.655.951 2.381c.914.957 2.114.924 2.649 1.027 1.921.183 8.16.239 8.16.239s5.044-.01 8.4-.248c.47-.057 1.491-.061 2.405-1.018.722-.726.956-2.38.956-2.38s.24-1.942.24-3.887V8.497c0-1.94-.24-3.886-.24-3.886Zm-14.24 7.913V5.779l6.483 3.384-6.483 3.36Z"
		/>
	</svg>
)

export default YouTube;
